/*!
 * © tix02.be 
 * 
 * This script will be loaded in footer
 * Do not append script that could be deferred in header 
 */
 
'use strict';


// APP 
import navbarInit from './app/navbar';
import searchformInit from './app/searchform';
import scrollerInit from './app/scroller';
// import barbaInit from './app/barba';
import scrollTriggerInit from './app/scrollTrigger';
import magneticInit from './app/magnetic';
import accordionInit from './app/accordion';
// import googleMapsInit from './app/google-maps';


// SHARED 

import useSwipers from './@tix02/init/swipers';

/*
 * Configure .scrollable (perfect-scrollbar dependent)
 * @need perfect-scrollbar
 */
//import useScrollable from "./@tix02/init/scrollable";
/*
 * Manage anchor links to be smooth
 * @need /polyfill/smoothscroll.min 
 */
import useAnchorLinks from './@tix02/init/anchor-links';
// import useOverlay from './@tix02/init/overlay';
import useBurgerMenu from './@tix02/init/burger-menu';
/*
 * Translated website? 
 * If you want a dropdown language selector, use this 
 */
//import useI18n from './@tix02/init/i18n';
/*
 * @need @tarekraafat/autocomplete.js
 */
import useSearchBox from './@tix02/init/searchbox';
import useImprovedForms from './@tix02/init/forms';
//import useTabs from "../tix02/init/tabs";

/* 
 * Web components 
 */
import './@tix02/uix/uix-switch'; 
//import './@tix02/component/web/uix-notification'; 
//import './@tix02/component/web/uix-modal';



(function() {
	navbarInit();
	searchformInit();
	scrollerInit();
	// barbaInit();
	scrollTriggerInit();
	magneticInit();
	
	accordionInit('.aside-nav.-accordion', {
		itemSelector: '.menu > .menu-item.has-children',
		itemBodySelector: '.submenu',
		itemHandlerSelector: ':scope > a',
	});
})();



(function() {
	//useScrollable();
	useAnchorLinks();
	useBurgerMenu({
		BUTTON: '#primary-nav-handler',
		BUTTON_CLOSE: '.navigation-close',
		ACTIVE_CLASSNAME: 'navigation-shown',
	});
	/*
	useI18n({
		SELECTOR: '',
		SELECTOR_TOGGLE: '',
		ACTIVE_CLASSNAME: '',
	});
	*/
	useSearchBox({
		FORM: '#search-form',
		INPUT: '#s',
	});
	useImprovedForms();
	useSwipers();
})();






// custom global functions 

let _userLocation = null;


app.saveUserData = async (formData) => {
	formData.append('_csrfToken', window.csrfToken);
	const response = await fetch(appUrls.userData, { method: 'POST', body: formData });
	return response.ok;
}


/**
 * Get the user location, if user allows
 */
app.requestUserLocation = function() {
	return new Promise((resolve, reject) => {
		if( _userLocation ) {
			resolve(_userLocation);
		}
	
		if (! 'geolocation' in navigator) {
			resolve(null);
		}
		
		const _saveUserPosition = (coords) => {
			_userLocation = [coords.latitude, coords.longitude];
			resolve(_userLocation);
			
			const formData = new FormData();
			formData.append('position_lat', coords.latitude);
			formData.append('position_lng', coords.longitude);
			app.saveUserData(formData); // save data 
		};
		
		const _onPosition = position => _saveUserPosition(position.coords);
		const _onError = error => reject(error);
		navigator.geolocation.getCurrentPosition(_onPosition, _onError);
	});
}



/**
 * Create a map
 * @param {string} elementId 
 * @param {Object} options - 
 * @returns {Promise} - map
 */
app.createMap = async function(elementId, options = {}) {
	if(! mapboxgl ) {
		return;
	}
	mapboxgl.accessToken = appConfig.mapbox.apiKey;
	
	let center;
	if(! options.center ) {
		try {
			center = await app.requestUserLocation();
		} catch(err) {
			//console.error(err);
			center = appConfig.mapbox.mapDefaultCenter;
		}
	}
	else {
		center = options.center;
	}
	
	const map = new mapboxgl.Map({
		container: elementId, 
		center: [center[1], center[0]], 
		zoom: options.zoom ?? 7, 
		style: `mapbox://styles/mapbox/${appConfig.mapbox.style}`,
	});
	
	return map;
};



app.addMapMarkersForProfiles = function(map, profiles, popup = false) {
	
	const _popup = (profile) => {
		const template = document.getElementById(popup);
		const clone = template.content.cloneNode(true);
		clone.querySelector('.popup--title').textContent = profile.title;
		if( profile.logo ) {
			const logo = document.createElement('img');
			logo.src = profile.logo.url;
			logo.setAttribute('alt', profile.logo.alt ?? profile.title);
			clone.querySelector('.popup--logo').appendChild(logo);
		}
		
		clone.querySelector('.popup--body address').textContent = profile.address;
		clone.querySelector('.popup--read-more-btn').setAttribute('href', profile.url);
		
		const serializer = new XMLSerializer();
		const html = serializer.serializeToString(clone);
		return new mapboxgl.Popup().setHTML(html);
	};
	
	
	profiles
		.filter(profile => profile.address && profile.geolocation)
		.forEach(profile => {
			const marker = new mapboxgl.Marker({ color: 'black' })
				.setLngLat([ profile.geolocation[1], profile.geolocation[0] ]);
			
			if( popup ) {
				try {
					marker.setPopup(_popup(profile));
				} catch(err) {}
			}
				
			marker.addTo(map);
		});
};



